export const stackGraph = [
  {
    id: 0,
    month: 'Jan',
    courseVisit: 10,
    courseSale: 40,
  },
  {
    id: 1,
    month: 'Feb',
    courseVisit: 10,
    courseSale: 5,
  },
  {
    id: 2,
    month: 'Mar',
    courseVisit: 30,
    courseSale: 15,
  },
  {
    id: 2,
    month: 'Mar',
    courseVisit: 60,
    courseSale: 45,
  },
  {
    id: 3,
    month: 'Apr',
    courseVisit: 66,
    courseSale: 35,
  },
  {
    id: 4,
    month: 'May',
    courseVisit: 60,
    courseSale: 45,
  },
  {
    id: 5,
    month: 'Jun',
    courseVisit: 80,
    courseSale: 75,
  },
  {
    id: 6,
    month: 'Jul',
    courseVisit: 80,
    courseSale: 75,
  },
  {
    id: 7,
    month: 'Aug',
    courseVisit: 30,
    courseSale: 75,
  },
  {
    id: 8,
    month: 'Sep',
    courseVisit: 80,
    courseSale: 45,
  },
  {
    id: 9,
    month: 'Oct',
    courseVisit: 60,
    courseSale: 35,
  },
  {
    id: 10,
    month: 'Nov',
    courseVisit: 30,
    courseSale: 35,
  },
  {
    id: 10,
    month: 'Dec',
    courseVisit: 30,
    courseSale: 35,
  },
];

export const doughnutData = [
  {
    label: 'Designing Course',
    data: 22,
    color: '#5372E7',
  },
  {
    label: 'Web Design',
    data: 50,
    color: '#EB91E8',
  },
  {
    label: 'Programming',
    data: 36,
    color: '#FF9F24',
  },
  {
    label: 'App Development',
    data: 36,
    color: '#97CDFF',
  },
  {
    label: 'UI & UX Design',
    data: 86,
    color: '#21BDCA',
  },
  {
    label: 'Business',
    data: 10,
    color: '#BABBFD',
  },
  {
    label: 'Education',
    data: 42,
    color: '#FF6967',
  },
  {
    label: 'Marketing',
    data: 62,
    color: '#E48890',
  },
];
export const doughnutDataInstructor = [
  {
    label: 'Designing Course',
    data: 22,
    color: '#5372E7',
  },
  {
    label: 'Web Design',
    data: 50,
    color: '#EB91E8',
  },
  {
    label: 'Web Design',
    data: 50,
    color: '#EB91E8',
  },
];

export const BarData = [
  {
    label: '5 stars',
    data: 22,
    color: 'red',
  },
  {
    label: '4 stars',
    data: 50,
    color: '#EB91E8',
  },
  {
    label: '3 Stars',
    data: 50,
    color: '#EB91E8',
  },
  {
    label: '2 Stars',
    data: 50,
    color: '#EB91E8',
  },
  {
    label: '1 Star',
    data: 50,
    color: '#EB91E8',
  },
];
